var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCommercialMarketing = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 54,
    viewBox: "0 0 41 54",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_276_1703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.2223 23.2778C39.3087 14.0423 33.5132 4.86416 24.2777 2.77778C15.0423 0.691397 5.86411 6.48686 3.77773 15.7223C1.69135 24.9578 7.48682 34.1359 16.7223 36.2223C25.9577 38.3087 35.1359 32.5132 37.2223 23.2778Z",
    fill: "#E3E6F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.498 37.3628C10.6509 37.3628 2.64133 29.3532 2.64133 19.5062C2.64133 9.65916 10.6509 1.64954 20.498 1.64954C30.345 1.64954 38.3546 9.65916 38.3546 19.5062C38.3546 29.3532 30.345 37.3628 20.498 37.3628ZM20.498 3.07546C11.4372 3.07546 4.06725 10.4455 4.06725 19.5062C4.06725 28.5669 11.4372 35.9369 20.498 35.9369C29.5587 35.9369 36.9287 28.5669 36.9287 19.5062C36.9287 10.4455 29.5587 3.07546 20.498 3.07546Z",
    fill: "#5A2FDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4302 34.6982H12.5495V39.4486H28.4302V34.6982Z",
    fill: "#E3E6F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1473 40.1616H11.8407V33.9854H29.1473V40.1616ZM13.2625 38.7357H27.7173V35.4113H13.2625V38.7357Z",
    fill: "#5A2FDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4302 39.4487H12.5495V44.1991H28.4302V39.4487Z",
    fill: "#E3E6F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1473 44.9161H11.8407V38.7399H29.1473V44.9161ZM13.2625 43.4902H27.7173V40.1658H13.2625V43.4902Z",
    fill: "#5A2FDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5496 44.2031H28.4303V44.525C28.4303 46.9694 26.4462 48.9576 23.9977 48.9576H16.9781C14.5336 48.9576 12.5455 46.9735 12.5455 44.525V44.2031H12.5496Z",
    fill: "#E3E6F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0017 49.6664H16.9821C14.1465 49.6664 11.8365 47.3605 11.8365 44.5249V43.4901H29.1432V44.5249C29.1432 47.3605 26.8372 49.6664 23.9976 49.6664H24.0017ZM13.2828 44.916C13.4784 46.782 15.0632 48.2405 16.9821 48.2405H24.0017C25.9206 48.2405 27.5013 46.782 27.7009 44.916H13.2869H13.2828Z",
    fill: "#5A2FDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.67509 20.2191C8.2799 20.2191 7.96213 19.9013 7.96213 19.5061C7.96213 15.4565 9.9299 11.6391 13.2299 9.29243C13.5517 9.06428 13.9958 9.1376 14.224 9.45945C14.4521 9.7813 14.3788 10.2254 14.0569 10.4535C11.1318 12.5354 9.38805 15.9169 9.38805 19.5061C9.38805 19.9013 9.07027 20.2191 8.67509 20.2191Z",
    fill: "#5A2FDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2109 25.1283H19.785V34.6983H21.2109V25.1283Z",
    fill: "#5A2FDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4696 26.2568L16.9781 21.7182L18.1066 20.8505L20.5307 24.0038L23.2807 20.8179L24.3603 21.7508L20.4696 26.2568Z",
    fill: "#5A2FDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4898 53.0683C18.2206 53.0683 16.375 51.2227 16.375 48.9535H17.801C17.801 50.4365 19.0069 51.6424 20.4898 51.6424C21.9728 51.6424 23.1787 50.4365 23.1787 48.9535H24.6046C24.6046 51.2227 22.7591 53.0683 20.4898 53.0683Z",
    fill: "#5A2FDE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_276_1703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 54,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCommercialMarketing, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Commercial-Marketing.4e8d7790.svg";
export { ForwardRef as ReactComponent };